import {GetHealthStates} from 'domain/usecases';
import {RemoteGetHealthStates} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthStates = (): GetHealthStates =>
	new RemoteGetHealthStates(
		makeBFFApiUrl(BookingFlowEndPoints.healthStates),
		makeAuthorizeHttpClientDecorator(),
	);
